import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { isAuth, useAsyncEffect } from '@recargas-dominicanas/core/utils';
import { useOpenPopup } from '@recargas-dominicanas/core/hooks';
import { AuthApi } from '../../api/auth.api';
import { useProductStore } from '../../stores/productStore';
import { useBusinessListStore } from '../../stores/businessListStore';
import { UserProfile } from '../../components/user-profile/user-profile.component';
import logo from '../../images/recargas-dominicanas.svg';
import errorImage from '../../images/server-error.png';
import { ErrorPage, Navbar, NavbarOption } from '@recargas-dominicanas/core/components';
import type { ICustomer } from '@recargas-dominicanas/core/types';
import { Header } from '../../components/header/header.component';
import { style } from './main.module.css';
import { useSalesStore } from '../../stores/salesStore';

export function Main() {

  const productStore = useProductStore();
  const businessListStore = useBusinessListStore();
  const salesStore = useSalesStore();
  const openProfile = useOpenPopup();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState<ICustomer | null>(null);
  const [isLoading, setLoading] = useState(true);
  const [loadFailed, setLoadFailed] = useState(false);

  useAsyncEffect(async () => {

    const auth = await isAuth('customer');

    if (!auth) return navigate('/login');

    try {

      const customer = await AuthApi.getUser();

      setCustomer(customer);

      await Promise.all([
        businessListStore.fetch(),
        productStore.fetch(),
        salesStore.fetchBalance(),
        salesStore.fetch()
      ]);
      
      setLoading(false);

    } catch {

      setLoadFailed(true);
    }
  });

  if (isLoading) {
    return null;
  }

  if (loadFailed) {
    return <ErrorPage image={errorImage}/>;
  }

  return (
    <div className={style.container}>
      <Header
        logo={logo}
        title='Recargas Dominicanas'
        name={`${customer?.name}, Distribuidor`} 
        onOpenProfile={openProfile.handleOpen}/>
      <div className={style.body}>
        <Navbar style={style.navBar}>
          <NavbarOption label='Negocios' align='top' icon='storefront' route='/'/>
          <NavbarOption label='Productos' align='top' icon='widgets' route='/products'/>
          <NavbarOption label='Ventas' align='top' icon='data_usage' route='/sales'/>
        </Navbar>
        <div className={style.content}>
          <Outlet/>
        </div>
      </div>
      {customer && (
        <UserProfile 
          open={openProfile.open}
          customer={customer}
          onClose={openProfile.handleClose}/>
      )}
    </div>
  );
}
